// Mirrors the inline script in index.html, which covers the entry bundle before any app code runs.
export const STALE_BUILD_RELOAD_KEY = 'sc-stale-build-reload';
// one recovery per minute, so a file that is really missing cannot turn into a reload loop
export const STALE_BUILD_RELOAD_COOLDOWN_MS = 60 * 1000;

// what browsers and Vite report when a lazily imported chunk or its CSS cannot be fetched
const CHUNK_LOAD_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export const isChunkLoadError = (error: unknown): boolean => CHUNK_LOAD_ERROR.test(String((error as Error)?.message ?? error));

const canRecover = (now: number): boolean => {
  try {
    const last = Number(sessionStorage.getItem(STALE_BUILD_RELOAD_KEY) || 0);

    if (now - last < STALE_BUILD_RELOAD_COOLDOWN_MS) {
      return false;
    }

    sessionStorage.setItem(STALE_BUILD_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
};

/**
 * A chunk of the running build is gone (a deploy replaced it), usually because a stale service
 * worker served an old index.html. Drop the service workers and their caches, then load the URL
 * again so it comes from the server. Returns false when it already tried within the cooldown.
 */
export const recoverFromStaleBuild = async (url: string = window.location.href, now = Date.now()): Promise<boolean> => {
  if (!canRecover(now)) {
    return false;
  }

  try {
    const registrations = await navigator.serviceWorker?.getRegistrations() ?? [];
    await Promise.all(registrations.map(registration => registration.unregister()));

    const cacheNames = await window.caches?.keys() ?? [];
    await Promise.all(cacheNames.map(name => window.caches.delete(name)));
  } catch {
    // the reload below still fetches what the server has
  }

  window.location.assign(url);
  return true;
};
